import React from 'react';
import { BotMessageSquare } from 'lucide-react';

interface TypingIndicatorProps {
  isVisible: boolean;
  className?: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  isVisible,
  className = ''
}) => {
  if (!isVisible) return null;

  return (
    <div className={`typing-indicator flex items-center space-x-2 px-4 py-3 ${className}`}>
      {/* Bot Avatar - Consistent with Trigger and Header */}
      <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center flex-shrink-0 border-2 border-[#D9F0FF]">
        <BotMessageSquare size={20} color="#0f3340" strokeWidth={2} />
      </div>

      {/* Typing Animation Container */}
      <div className="typing-bubble bg-gray-100 rounded-2xl rounded-bl-sm px-4 py-3 max-w-xs">
        <div className="flex items-center space-x-1">
          <span className="text-sm text-gray-600 mr-2">TSP Assistant is typing</span>
          <div className="flex space-x-1">
            <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: '#a8ddef', animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: '#83cbe6', animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: '#5eb8db', animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Alternative minimal typing indicator
export const MinimalTypingIndicator: React.FC<TypingIndicatorProps> = ({
  isVisible,
  className = ''
}) => {
  if (!isVisible) return null;

  return (
    <div className={`minimal-typing-indicator px-4 py-2 ${className}`}>
      <div className="flex items-center space-x-2 text-gray-500 text-sm">
        <div className="flex space-x-1">
          <div className="w-1 h-1 rounded-full animate-pulse" style={{ backgroundColor: '#a8ddef', animationDelay: '0ms' }}></div>
          <div className="w-1 h-1 rounded-full animate-pulse" style={{ backgroundColor: '#83cbe6', animationDelay: '200ms' }}></div>
          <div className="w-1 h-1 rounded-full animate-pulse" style={{ backgroundColor: '#5eb8db', animationDelay: '400ms' }}></div>
        </div>
        <span>Assistant is typing...</span>
      </div>
    </div>
  );
};

// Floating typing indicator for when chat is minimized
export const FloatingTypingIndicator: React.FC<TypingIndicatorProps> = ({
  isVisible,
  className = ''
}) => {
  if (!isVisible) return null;

  return (
    <div className={`floating-typing-indicator absolute -top-12 left-4 bg-white shadow-lg rounded-full px-3 py-2 ${className}`}>
      <div className="flex items-center space-x-2">
        <div className="flex space-x-1">
          <div className="w-1.5 h-1.5 rounded-full animate-bounce" style={{ backgroundColor: '#a8ddef', animationDelay: '0ms' }}></div>
          <div className="w-1.5 h-1.5 rounded-full animate-bounce" style={{ backgroundColor: '#83cbe6', animationDelay: '150ms' }}></div>
          <div className="w-1.5 h-1.5 rounded-full animate-bounce" style={{ backgroundColor: '#5eb8db', animationDelay: '300ms' }}></div>
        </div>
        <span className="text-xs text-gray-600">Typing...</span>
      </div>
    </div>
  );
};

export default TypingIndicator;